import { Button, Checkbox, FormControlLabel, IconButton } from '@mui/material'
import React, { useState } from 'react'
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import EditDialog from '../../../Modals/EditBrandDialog';
import ConfirmDialog from '../../../Modals/ConfirmDialog';
import { useDeleteBrandMutation, useUpdateBrandMutation } from '../../../../features/fullApi';


const Brand = (brand) => {

    const [open, setOpen] = useState(false)
    const [openEdit, setOpenEdit] = useState(false)
    const user = JSON.parse(localStorage.getItem('user'))


    const openModalEditItem = ((brand) => {
        setOpenEdit(true)
      })

      const editItemMessage = "You are updating this item"
  
      const [updateBrand] = useUpdateBrandMutation()
      const [deleteBrand] = useDeleteBrandMutation()
    
      const message = "Are you sure you want to delete this brand ?";
    
      const openDeleteModal = (() => {
        setOpen(true)
      })
    
      const handleUpdateBrand = ((brand) => {
        setOpenEdit(false)
        updateBrand({_id: brand.id._id, brandName: brand.brandName}, { 
          headers: {
            'Token': `Bearer ${user?.accessToken}`
          }
        }).then(
        )
      })
    
    
      const handleDelete = (async (brandId) => {  
        deleteBrand({id: brandId})
        setOpen(false)
      })

  return (
    <>

      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      {user?.isAdmin && (
          <div style={{display: 'flex', justifyContent: 'center'}}>
              <Button aria-label="Edit Item" onClick={() => openModalEditItem(brand.brand._id)}>
                <EditIcon style={{color: 'orange'}}/>
              </Button>
              <Button aria-label="Delete product" onClick={() => openDeleteModal(brand.brand._id)} size="small">
              <DeleteIcon style={{color: 'red'}}/>
              </Button>
          </div>
      )}
      </div>
      <EditDialog openEdit={openEdit} handleUpdateBrand={handleUpdateBrand} setOpenEdit={setOpenEdit} item={brand.brand} message={editItemMessage}>         
      </EditDialog>
      <ConfirmDialog open={open} handleDelete={handleDelete} setOpen={setOpen} item={brand.brand} message={message}></ConfirmDialog>
  </>
  )
}

export default Brand